import { ApiError } from '../errors/api-error.js';

export class TenantMfaSettingsApi {
    constructor(client, basePath = '/tenant-mfa-settings') {
        this.client = client;
        this.basePath = basePath;
    }

    async get() {
        try {
            const response = await this.client.get(this.basePath);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async update(data) {
        try {
            const response = await this.client.put(this.basePath, data);
            return response.data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
